"use strict";

var _interopRequireDefault = require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/web.dom.iterable");

var _typeof2 = _interopRequireDefault(require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime-corejs2/helpers/typeof"));

var _objectSpread2 = _interopRequireDefault(require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime-corejs2/helpers/objectSpread2"));

var _index = _interopRequireDefault(require("@/components/Pagination/index"));

var _waves = _interopRequireDefault(require("@/directive/waves"));

var _lang = _interopRequireDefault(require("@/lang"));

var _httpUtils = _interopRequireDefault(require("@/utils/http-utils"));

var _PermissionPage = _interopRequireDefault(require("@/components/Page/PermissionPage"));

var _PermissionSimplePage = _interopRequireDefault(require("@/components/Page/PermissionSimplePage"));

var _CustomTableColumn = _interopRequireDefault(require("@/mixins/CustomTableColumn"));

var _vuex = require("vuex");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// Custom Table Column Mixins (Omega Theme)
var _default = {
  name: "payChannelGroupCost:view",
  mixins: [_CustomTableColumn.default],
  props: ['channelGroupId', 'channelGroupName'],
  extends: _PermissionPage.default,
  components: {
    Pagination: _index.default,
    PermissionSimplePage: _PermissionSimplePage.default
  },
  directives: {
    waves: _waves.default
  },
  data: function data() {
    return {
      tableKey: 0,
      list: [],
      agentList: [],
      channelList: [],
      channelGroupList: [],
      total: 0,
      listLoading: true,
      updateChannelFlag: false,
      addDialogVisible: false,
      forceDialogVisible: false,
      addNotedDialogVisible: false,
      batchUpdateCostDialogVisible: false,
      notedFlag: false,
      isForced: false,
      queryParameter: {
        pageNum: 1,
        pageSize: 10,
        channelGroupId: "",
        channelId: ""
      },
      addInformationParameter: {
        id: '',
        channelId: '',
        minAmount: '',
        netwayCode: '',
        remark: '',
        channelGroupId: '',
        state: '',
        weight: ''
      },
      updateCostParameter: {
        minAmount: "",
        costIds: [],
        channelGroupId: ""
      },
      remarkMessage: "",
      downloadLoading: false,
      multipleSelection: [],
      netwayCodeEnums: [],
      rules: {
        channelGroupName: [{
          required: true,
          message: _lang.default.t("channel.smsChannelGroupNameText") + " " + _lang.default.t("warningMessage.cannotBeEmpty"),
          trigger: "change"
        }],
        channelDetail: [{
          required: true,
          message: _lang.default.t("channel.channelNameText") + " " + _lang.default.t("warningMessage.cannotBeEmpty"),
          trigger: "change"
        }]
      }
    };
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['costStatusOption', 'statusOptions', 'useOptions', 'numberRegionOptions', 'netwayCodeOption']), {
    showCallerInput: function showCallerInput() {
      return process.env.VUE_APP_SHOW_CALLER_INPUT === '1';
    }
  }),
  created: function created() {
    this.handleNetwayCode(); //If channel group id is undefined, return to previous page

    if (this.channelGroupId !== undefined) {
      this.initList();
      this.getList();
    } else {}
  },
  mounted: function mounted() {
    var _this2 = this;

    //If channel group id is undefined, return to previous page
    if (this.channelGroupId !== undefined) {
      this.initList();
      this.getList();
    } else {
      //Go back to previous webpage
      this.$store.dispatch('tagsView/delView', this.$route).then(function () {
        _this2.$router.go(-1);
      });
    }
  },
  methods: {
    handleNetwayCode: function handleNetwayCode() {
      this.netwayCodeEnums = this.$store.getters.netwayCodeEnums;

      if (this.netwayCodeEnums == null || (0, _typeof2.default)(this.netwayCodeEnums) != 'object' || this.netwayCodeEnums.length < 1) {
        this.netwayCodeEnums = this.netwayCodeOption;
      }
    },
    convertNetwayCodeToName: function convertNetwayCodeToName(key) {
      var found = '';
      this.netwayCodeEnums.forEach(function (status) {
        if (status.key == key) {
          found = status.display_name;
          return;
        }
      });
      return found;
    },
    convertChannelIdToChannelName: function convertChannelIdToChannelName(channelId) {
      var found = '';
      this.channelList.forEach(function (status) {
        if (parseInt(status.channelId) == channelId) {
          found = status.channelName;
          return;
        }
      });
      return found;
    },
    getNetwayCodeByPayChannel: function getNetwayCodeByPayChannel() {
      var _this3 = this;

      this.channelList.forEach(function (status) {
        if (parseInt(status.channelId) == _this3.addInformationParameter.channelId) {
          _this3.addInformationParameter.netwayCode = status.netwayCode;
          return;
        }
      });
    },
    initList: function initList() {
      this.getChannelList(); // this.getAreaNumberList();
    },
    //Initial channel list
    getChannelList: function getChannelList() {
      var _this4 = this;

      _httpUtils.default.post("payChannel", "getPayChannelOption", null, null).then(function (res) {
        _this4.channelList = res.data;
      });
    },
    getList: function getList() {
      var _this5 = this;

      //Set the loading button for table
      this.listLoading = true; //Get channel group name from props

      this.addInformationParameter.channelGroupName = this.channelGroupName; //Get search parameters

      var params = this.getQueryParams();

      _httpUtils.default.post("payChannelGroupCost", "list", null, params).then(function (res) {
        _this5.list = res.data.rows;
        _this5.total = res.data.total;
      }).finally(function () {
        _this5.listLoading = false;
      });

      setTimeout(function () {
        _this5.listLoading = false;
      }, 1 * 1000);
    },
    //Get search parameter for backend service
    getQueryParams: function getQueryParams() {
      return {
        pageNum: this.queryParameter.pageNum,
        pageSize: this.queryParameter.pageSize,
        channelId: this.queryParameter.channelId,
        channelGroupId: this.channelGroupId
      };
    },
    //Refresh table
    handleFilter: function handleFilter() {
      //Reset the page number of table
      this.queryParameter.pageNum = 1;
      this.getList();
    },
    //Get input parameters for backend service
    getAddInformationParameter: function getAddInformationParameter() {
      return {
        id: this.addInformationParameter.id,
        channelId: this.addInformationParameter.channelId,
        remark: this.addInformationParameter.remark,
        minAmount: this.addInformationParameter.minAmount,
        netwayCode: this.addInformationParameter.netwayCode,
        channelGroupId: this.channelGroupId,
        state: this.addInformationParameter.state,
        weight: this.addInformationParameter.weight
      };
    },
    //Fill in parameters for adding member in channel group
    handleAddCheck: function handleAddCheck() {
      this.addDialogVisible = true;
      this.handleReset();
    },
    //Show remark for adding channel in channel group
    handleAddNoted: function handleAddNoted() {
      this.addNotedDialogVisible = true;
      this.remarkMessage = this.$t("warningMessage.channelGroupAddCostRemark");
    },
    handleAddCost: function handleAddCost() {
      var _this6 = this;

      this.addNotedDialogVisible = false;

      var _this = this;

      this.$refs["addInformation"].validate(function (valid) {
        if (valid) {
          var params = _this.getAddInformationParameter();

          if (_this.updateChannelFlag) {
            _httpUtils.default.post("payChannelGroupCost", "update", null, params).then(function (res) {
              if (res.code === 200) {
                _this6.$message({
                  message: _lang.default.t("warningMessage.updateGroupSuccessMessage"),
                  type: "success"
                });
              }

              if (res.code === 500) {
                _this6.$message({
                  message: e.message,
                  type: "error"
                });
              }

              _this6.handleResetAdd();

              _this6.handleFilter();
            }).catch(function (e) {
              _this6.$message({
                message: e.message,
                type: "error"
              });
            });
          } else {
            _httpUtils.default.post("payChannelGroupCost", "add", null, params).then(function (res) {
              if (res.code === 200) {
                _this6.$message({
                  message: _lang.default.t("warningMessage.addGroupSuccessMessage"),
                  type: "success"
                });
              }

              if (res.code === 500) {
                _this6.$message({
                  message: e.message,
                  type: "error"
                });
              }

              _this6.handleResetAdd();

              _this6.handleFilter();
            }).catch(function (e) {
              _this6.$message({
                message: e.message,
                type: "error"
              });
            });
          }

          _this6.$refs["addInformation"].clearValidate();
        } else {
          return false;
        }
      });
    },
    deleteGroup: function deleteGroup(groupIds) {
      var _this7 = this;

      if (groupIds.length > 0) {
        _httpUtils.default.post("payChannelGroupCost", "batchDelete", null, groupIds).then(function (res) {
          _this7.$message({
            message: _lang.default.t("warningMessage.deleteRecordSuccessMessage"),
            type: "success"
          });

          _this7.handleFilter();
        }).catch(function (err) {
          _this7.$message({
            message: err.message,
            type: "error"
          });
        });
      }
    },
    handleDelete: function handleDelete(id) {
      var _this8 = this;

      this.$confirm(_lang.default.t("warningMessage.channelGroupDeleteCostRemark"), _lang.default.t("warningMessage.deleteRecordMessage"), {
        confirmButtonText: _lang.default.t("common.confirm"),
        cancelButtonText: _lang.default.t("common.cancel"),
        type: "warning"
      }).then(function () {
        var ids = [];
        ids.push(id);

        _this8.$nextTick(function (_) {
          _this8.deleteGroup(ids);
        });
      }).catch(function (_) {});
    },
    handleBatchDelete: function handleBatchDelete() {
      var _this9 = this;

      var _this = this;

      if (!_this.multipleSelection.length) {
        this.$message({
          message: _lang.default.t("warningMessage.selectRecordToDeleteMessage"),
          type: "error"
        });
      } else {
        this.$confirm(_lang.default.t("warningMessage.channelGroupDeleteCostRemark"), _lang.default.t("warningMessage.deleteRecordMessage"), {
          confirmButtonText: _lang.default.t("common.confirm"),
          cancelButtonText: _lang.default.t("common.cancel"),
          type: "warning"
        }).then(function () {
          var ids = [];

          for (var item in _this.multipleSelection) {
            ids.push(_this.multipleSelection[item].id);
          }

          _this9.$nextTick(function (_) {
            _this9.deleteGroup(ids);
          });
        }).catch(function (_) {});
      }
    },
    //Fill in parameters for updating member in channel group
    handleUpdateCheck: function handleUpdateCheck(row) {
      this.addInformationParameter.id = row.id;
      this.addInformationParameter.channelId = parseInt(row.channelId); // this.getAreaNumberList();

      this.addInformationParameter.minAmount = row.minAmount;
      this.addInformationParameter.createUserName = row.createUserName;
      this.addInformationParameter.remark = row.remark;
      this.addInformationParameter.state = row.state;
      this.addInformationParameter.weight = row.weight;
      this.addDialogVisible = true;
      this.updateChannelFlag = true;
    },
    handleBatchUpdateCostCheck: function handleBatchUpdateCostCheck() {
      var _this10 = this;

      var _this = this;

      if (!_this.multipleSelection.length) {
        this.$message({
          message: _lang.default.t("warningMessage.selectChannelGroupCostMessage"),
          type: "error"
        });
      } else {
        this.updateCostParameter.costIds = [];

        for (var item in _this.multipleSelection) {
          this.updateCostParameter.costIds.push(_this.multipleSelection[item].id);
        }

        this.$nextTick(function (_) {
          _this10.batchUpdateCostDialogVisible = true;
        });
      }
    },
    //Update value of selected costs in the channel group
    handleBatchUpdateCost: function handleBatchUpdateCost() {
      var _this11 = this;

      this.listLoading = true;
      var params = {
        costIds: this.updateCostParameter.costIds,
        channelGroupId: this.channelGroupId,
        minAmount: this.updateCostParameter.minAmount
      };

      _httpUtils.default.post("payChannelGroupCost", "batchUpdateCost", null, params).then(function (res) {
        _this11.$message({
          message: _lang.default.t("warningMessage.updateGroupDetailSuccessMessage"),
          type: "success"
        });

        _this11.handleResetUpdateCost();

        _this11.handleFilter();
      }).catch(function (err) {
        _this11.$message({
          message: err.message,
          type: "error"
        });
      });

      setTimeout(function () {
        _this11.listLoading = false;
      }, 1 * 1000);
    },
    //Update value of all costs in the channel group
    handleUpdateAllCost: function handleUpdateAllCost() {
      var _this12 = this;

      this.listLoading = true;
      var params = {
        channelGroupId: this.channelGroupId,
        minAmount: this.updateCostParameter.minAmount
      };

      _httpUtils.default.post("payChannelGroupCost", "updateAllCost", null, params).then(function (res) {
        _this12.$message({
          message: _lang.default.t("warningMessage.updateGroupDetailSuccessMessage"),
          type: "success"
        });

        _this12.handleResetUpdateCost();

        _this12.handleFilter();
      }).catch(function (err) {
        _this12.$message({
          message: err.message,
          type: "error"
        });
      });

      setTimeout(function () {
        _this12.listLoading = false;
      }, 1 * 1000);
    },
    handleReset: function handleReset() {
      this.addNotedDialogVisible = false;
      this.addInformationParameter.id = null;
      this.addInformationParameter.channelId = '';
      this.addInformationParameter.remark = '';
      this.addInformationParameter.minAmount = '';
      this.addInformationParameter.netwayCode = '';
    },
    //Reset validate for input parameters
    handleResetAdd: function handleResetAdd() {
      var _this13 = this;

      this.addDialogVisible = false;
      this.updateChannelFlag = false;
      this.handleReset();
      this.$nextTick(function () {
        _this13.$refs["addInformation"].clearValidate();
      });
    },
    //Reset parameter for update cost dialog
    handleResetUpdateCost: function handleResetUpdateCost() {
      this.batchUpdateCostDialogVisible = false;
      this.updateCostParameter.costIds = [];
      this.updateCostParameter.costValue = "";
    },
    convertOrgStatus: function convertOrgStatus(key) {
      var found = key;
      this.statusOptions.forEach(function (item) {
        if (item.key == key.toString()) {
          found = item.display_name;
          return;
        }
      });
      return found;
    },
    convertChannelId: function convertChannelId(id) {
      var found = id;
      this.channelList.forEach(function (channel) {
        if (channel.channelId == id) {
          found = channel.channelName;
          return;
        }
      });
      return found;
    },
    //Handle add check boxes for table
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    }
  }
};
exports.default = _default;